<div class="flex flex-col">
  <div class="flex flex-row py-2">
    <span>{{item['fehlerart']}}</span>
  </div>
</div>
